import React from "react";

/**
 * ErrorBoundary - catches React render errors in children and shows a friendly
 * fallback UI instead of a white screen. Use to wrap critical modal sections
 * (e.g., Item Requests, Pending Transfers) where bad data could crash rendering.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof this.props.onReset === "function") {
      this.props.onReset();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="p-6 bg-red-50 border-2 border-red-300 rounded-lg text-center"
          data-testid="error-boundary-fallback"
        >
          <div className="text-red-600 font-semibold mb-2">
            ⚠️ Nagka-error sa pag-display ng data na 'to
          </div>
          <div className="text-sm text-red-700 mb-3">
            {this.state.error?.message || "Unknown error"}
          </div>
          <p className="text-xs text-gray-600 mb-3">
            Pakipindot ang button sa baba para i-reset. Kung tuloy-tuloy ito,
            screenshot mo at ipa-check kay admin.
          </p>
          <button
            onClick={this.reset}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            data-testid="error-boundary-reset"
          >
            Reset & Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
